applications.classy.controller({
    name: 'SideNavController',
    inject: ['$scope', '$location', '$timeout', 'BinService', 'BinFactory', '$filter', '$http', 'TabsService',
        '$state', 'ApplicationsSubNavbarService', '$stateParams', 'ApplicationService', 'AlertService',
        '$location', '$interval', 'authServiceFactory', 'CalculationService', 'TabsService', '$filter',
        'ApplicationService', 'MainContentService', 'authServiceFactory', '$interval'],
    init: function()
    {
        this.$.versionNo = versionNo;
        this.$.ApplicationService = this.ApplicationService;
        this.$.BinFactory = this.BinFactory;
        this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;
        this.$.location = this.$location;
        this.$.BinService = this.BinService;
        this.$.$stateParams = this.$stateParams;
        this.$.Divisions = [];
        this.$.items = this.BinFactory.getApplications();
        this.$.MainContentService = this.MainContentService;
        //This is to build the grade options, this should be build from grades service
        for (var i = 0; i < this.$.items.length; i++)
        {
            let t = this.$.items[i].Division_Code;
            for (var j = 0; j < t.length; j++)
                this.$.Divisions[t[j].split('-')[0]] = 1;
        }

        if(this.authServiceFactory.isFollower())
        { 
            var parent = this;
            this.socketApp.on('echo', function (data) {
                parent.socketApp.emit('echo', data);
            });
            /*
            this.socketApp.addListener('newapp', function (data) {
                console.log("it happened");
                var app = {};
                parent.authServiceFactory.unlocked = 1;
                if (parent.$stateParams.applicationID !== data.applicationID) {
                    app.applicationID = data.applicationID;
                    parent.ApplicationsSubNavbarService.applicationClick(app, false);
                }
            });
            /*
            var parent = this;
            var application = this.$interval(function() {
                parent.$http.get("/api/school/" + parent.authServiceFactory.getAuth().schoolID + "/leaderApplication").then(function(results) {
                    var app = {};
                    parent.authServiceFactory.unlocked = 1;
                    if (results.data[0].taxTab == 0)
                        parent.TabsService.newTabs[1].disabled = true;
                    else
                        parent.TabsService.newTabs[1].disabled = false;
                    if (parent.$stateParams.applicationID !== results.data[0].applicationID)
                    {
                        app.applicationID = results.data[0].applicationID;
                        parent.ApplicationsSubNavbarService.applicationClick(app, false);
                    }
                })
            }, 5000);
*/
        };
    }
});
